import { render } from "./Help.vue?vue&type=template&id=0de3d7fa&scoped=true"
import script from "./Help.vue?vue&type=script&lang=js"
export * from "./Help.vue?vue&type=script&lang=js"

import "./Help.vue?vue&type=style&index=0&id=0de3d7fa&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0de3d7fa"

export default script